import React, { useMemo } from "react";

const rand = (min, max) => Math.random() * (max - min) + min;

export const MagicalBackground = () => {
  const stars = useMemo(
    () =>
      Array.from({ length: 55 }).map((_, i) => {
        const size = rand(1, 3.5);
        const palette = ["#ffffff", "#f0d98a", "#cfe6ff"];
        return {
          id: i,
          left: rand(0, 100),
          top: rand(0, 100),
          size,
          color: palette[Math.floor(rand(0, palette.length))],
          dur: rand(2.5, 6),
          delay: rand(0, 5),
        };
      }),
    []
  );

  const petals = useMemo(
    () =>
      Array.from({ length: 12 }).map((_, i) => ({
        id: i,
        left: rand(0, 100),
        dur: rand(12, 22),
        delay: rand(0, 18),
        size: rand(6, 12),
        color: ["#f0d98a", "#e9c9f5", "#cfe6ff", "#f8d7e3"][Math.floor(rand(0, 4))],
      })),
    []
  );

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
      {stars.map((s) => (
        <span
          key={s.id}
          className="star"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: s.size,
            height: s.size,
            background: s.color,
            boxShadow: `0 0 ${s.size * 2.5}px ${s.color}`,
            "--dur": `${s.dur}s`,
            "--delay": `${s.delay}s`,
          }}
        />
      ))}
      {petals.map((p) => (
        <span
          key={p.id}
          className="petal"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            borderRadius: "50% 0 50% 50%",
            background: p.color,
            opacity: 0.7,
            animationDuration: `${p.dur}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
};
